import { Action } from '@reduxjs/toolkit';
import { SET_APP_STATE, SET_LOADING_STATE } from '../actions';
import { copyObject } from '../utility';

type loadingStates = {
  customerGroups: boolean;
  [key: string]: boolean;
};

const defaultState = {
  saving: false,
  savingClient: false,
  savingProject: false,
  savingProjectWorkflow: false,
  savingVehicle: false,
  savingFacility: false,
  loading: {} as loadingStates,
};

export type AppState = typeof defaultState;

export default function (
  state: AppState = defaultState,
  action: Action & { payload?: Record<string, any> }
) {
  switch (action.type) {
    case SET_APP_STATE:
      return { ...copyObject(state), ...action.payload };
    case SET_LOADING_STATE:
      return { ...copyObject(state), loading: { ...state.loading, ...action.payload } };
    default:
      return state;
  }
}
